import { config } from "JS/Config";
import { ExternalSSOService } from "JS/Services/ExternalSSO";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { useCallback, useEffect, useState } from "react";

export const useExternalSSO = (
    resourceKey: string,
    onError: () => void,
    skip: boolean = false,
) => {
    const service = new ExternalSSOService();
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState<string>();
    const { enqueueSnackbar } = useSnackbar();
    const fetch = useCallback(() => {
        setLoading(true);
        service
            .getExternalSSO(resourceKey, config.xTenantId.toUpperCase())
            .then((r) => setResponse(r.data))
            .catch((e) => {
                enqueueSnackbar(e.message, {
                    variant: "error",
                });
                onError();
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!skip) fetch();
    }, [skip]);
    return {
        loading,
        response,
    };
};
